import { MouseEvent, useId, type ReactNode } from 'react';
import clsx from 'clsx';
import styles from './InputShared.module.scss';

interface Props {
  bottom?: ReactNode;
  children: ReactNode | ((args: { id: string }) => ReactNode);
  classNames?: { children: string };
  end?: ReactNode;
  extra?: ReactNode;
  id?: string;
  label?: string;
  name?: string;
  onClick?: () => void;
  start?: ReactNode;
  top?: ReactNode;
  valid?: boolean;
}

export function InputShared({
  bottom,
  children,
  classNames,
  end,
  extra,
  label,
  name,
  start,
  top,
  valid,
  ...props
}: Props) {
  const id = useId();

  function onClick(event: MouseEvent<HTMLDivElement>) {
    if (event.target === event.currentTarget) {
      props.onClick?.();
    }
  }

  return (
    <div
      className={clsx(
        styles['input'],
        valid === false && styles['input-invalid'],
      )}
      onClick={onClick}
    >
      {top && <div>{top}</div>}
      <div className={styles['main']}>
        {start && <div className={clsx(styles['start'])}>{start}</div>}
        <div className={clsx(styles['content'])}>
          <label
            className={clsx(styles['label'])}
            htmlFor={props.id != null ? (props.id ? props.id : undefined) : id}
          >
            {label}
          </label>
          <div className={clsx(styles['children'], classNames?.children)}>
            {typeof children === 'function' ? children({ id }) : children}
          </div>
        </div>
        {end && (
          <div className={clsx(styles['end'])} onClick={onClick}>
            {end}
          </div>
        )}
      </div>
      {bottom && <div>{bottom}</div>}
    </div>
  );
}
